export default {
    data() {
        return {
            validationRules: {
                file: [(v) => !!v || t('default::validation.field.csv_file')],
            },
        };
    },
    computed: {
        form() {
            return this.$store.state.uploadPdf.form;
        },
        loading: {
            get() {
                return this.$store.state.uploadPdf.loading;
            },
            set(loading) {
                this.$store.dispatch('uploadPdf/setLoading', loading);
            },
        },
        patientStatusOptions() {
            return this.$store.state.patients.patientStatusOptions;
        },
    },
    mounted() {
        this.$store.dispatch('patients/loadPatientStatusOptions');
        this.removePatientFromLoaclStorage();
    },
    created() {},
    methods: {
        removePatientFromLoaclStorage() {
            const data = { item: 'patient', data: false };
            this.$root.setLocalStorage(data, 'remove');
        },
        processFile(file) {
            if (!file) {
                return false;
            }
            this.loading = true;
            this.$root.setLoading(true);
            const formData = new FormData();
            formData.append('file', this.form.file);
            return axios
                .post(route('api.v1.patients.pdf'), formData)
                .then((response) => {
                    const data = _.cloneDeep(response.data);
                    const currentUserStatus = this.patientStatusOptions.find((x) => x.value == data.status);
                    if (currentUserStatus) {
                        data.is_registered = currentUserStatus.registered;
                    }
                    const patient = { item: 'patient', data };
                    this.$root.setLocalStorage(patient, 'add');
                    _.delay(() => {
                        this.$root.goTo(route('patients.create', { pdf: true }));
                    }, 10);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        const errors = Object.values(error.response.data.errors)
                            .map((x) => x.errors.join('<br/>'))
                            .join(',');
                        this.$root.notify('error', errors);
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => {
                    _.delay(() => {
                        this.$root.setLoading(false);
                        this.loading = false;
                    }, 500);
                });
        },
    },
};
